export const STATE_NAME = 'ingredients';

export const FETCH_INGREDIENTS = 'INGREDIENT_FETCH_INGREDIENTS';
export const FETCH_INGREDIENTS_DONE = 'INGREDIENT_FETCH_INGREDIENTS_DONE';
export const FETCH_INGREDIENTS_FAIL = 'INGREDIENT_FETCH_INGREDIENTS_FAIL';

export const FETCH_MARKET_INGREDIENTS = 'INGREDIENT_FETCH_MARKET_INGREDIENTS';
export const FETCH_MARKET_INGREDIENTS_DONE =
  'INGREDIENT_FETCH_MARKET_INGREDIENTS_DONE';
export const FETCH_MARKET_INGREDIENTS_FAIL =
  'INGREDIENT_FETCH_MARKET_INGREDIENTS_FAIL';

export const FETCH_INGREDIENT = 'INGREDIENT_FETCH_INGREDIENT';
export const FETCH_INGREDIENT_DONE = 'INGREDIENT_FETCH_INGREDIENT_DONE';
export const FETCH_INGREDIENT_FAIL = 'INGREDIENT_FETCH_INGREDIENT_FAIL';

export const FETCH_GLOBAL_INGREDIENTS = 'INGREDIENT_FETCH_GLOBAL_INGREDIENTS';
export const FETCH_GLOBAL_INGREDIENTS_DONE =
  'INGREDIENT_FETCH_GLOBAL_INGREDIENTS_DONE';
export const FETCH_GLOBAL_INGREDIENTS_FAIL =
  'INGREDIENT_FETCH_GLOBAL_INGREDIENTS_FAIL';

export const FETCH_EXCLUDED_INGREDIENTS =
  'INGREDIENT_FETCH_EXCLUDED_INGREDIENTS';
export const FETCH_EXCLUDED_INGREDIENTS_DONE =
  'INGREDIENT_FETCH_EXCLUDED_INGREDIENTS_DONE';
export const FETCH_EXCLUDED_INGREDIENTS_FAIL =
  'INGREDIENT_FETCH_EXCLUDED_INGREDIENTS_FAIL';

export const EXCLUDE_INGREDIENTS = 'INGREDIENT_EXCLUDE_INGREDIENTS';
export const EXCLUDE_INGREDIENTS_DONE = 'INGREDIENT_EXCLUDE_INGREDIENTS_DONE';
export const EXCLUDE_INGREDIENTS_FAIL = 'INGREDIENT_EXCLUDE_INGREDIENTS_FAIL';

export const INCLUDE_INGREDIENTS = 'INGREDIENT_INCLUDE_INGREDIENTS';
export const INCLUDE_INGREDIENTS_DONE = 'INGREDIENT_INCLUDE_INGREDIENTS_DONE';
export const INCLUDE_INGREDIENTS_FAIL = 'INGREDIENT_INCLUDE_INGREDIENTS_FAIL';
